/**
 * useExecutionLogs Hook
 *
 * React Query hook for fetching job execution logs.
 */

import { useQuery } from "@tanstack/react-query";
import { jobExecutionService } from "../../../api/job-execution.service";
import type { ExecutionLogsQuery, ExecutionLogsResponse } from "../../../types/elt-job-execution.types";

export const EXECUTION_LOGS_QUERY_KEY = "executionLogs";

export function useExecutionLogs(tenantId: string, jobExecutionId: string, query?: ExecutionLogsQuery) {
  return useQuery<ExecutionLogsResponse, Error>({
    queryKey: [EXECUTION_LOGS_QUERY_KEY, tenantId, jobExecutionId, query],
    queryFn: () => jobExecutionService.getExecutionLogs(tenantId, jobExecutionId, query),
    enabled: !!tenantId && !!jobExecutionId,
    staleTime: 30000, // Consider data fresh for 30 seconds
  });
}
